import axios from 'axios';
import {URL} from '../const/general';

axios.defaults.withCredentials = true

const axAuth = axios.create({
    baseURL: URL.AUTH_BASE,
})
export default axAuth;